import React, { useContext, useEffect, useState } from 'react';
import api from '../api/api';
import { Context } from './global-data-provider';

export const PostsListContext = React.createContext([]);

function CategoryPostsListProvider(props) {
  const { categories, deletedPostManager } = useContext(Context);
  const p = {};

  [p.postLoaded, p.setPostLoaded] = useState(false);
  [p.hasMore, p.setHasMore] = useState(false);
  [p.posts, p.setPosts] = useState([]);
  [p.category, p.setCategory] = useState(null);
  [p.categoryLoaded, p.setCategoryLoaded] = useState('loading');
  [p.data, p.setData] = useState({
    category: undefined,
    uniqTitle: undefined,
    pageNumber: undefined,
  });
  [p.pageNumber, p.setPageNumber] = useState(0);

  useEffect(() => {
    if (p.data.category !== undefined && p.data.pageNumber !== undefined) {
      p.loadPosts(p.data.category, p.data.pageNumber);
    }

    // find and set category.
    if (p.data.category !== undefined) {
      let found = false;
      Object.keys(categories).map((key) => {
        if (parseInt(categories[key].id) === parseInt(p.data.category) && categories[key].uniq_title === p.data.uniqTitle) {
          p.setCategory(categories[key]);
          if (p.categoryLoaded !== 'ok') {
            p.setCategoryLoaded('ok');
          }
          found = true;
        }
      });
      if (found === false) {
        p.setCategoryLoaded('error');
      }
    }
  }, [p.data]);

  p.loadPosts = (cat, pn) => {
    if (pn === 0 || p.hasMore) {
      api.getPosts(cat, pn, deletedPostManager.getListCount()).then((response) => {
        if (response.posts) {
          p.setPosts(p.createPostsList(response.posts));

          p.setPostLoaded(true);

          p.setHasMore(response.has_more);

          p.setPageNumber(pn);
        } else {
          p.setHasMore(false);
        }
      });
    }
  };

  p.createPostsList = (list) => {
    let postList = [];
    for (let i = 0; i < list.length / 3; i++) {
      postList[i] = [];
      for (let j = 0; j < 3; j++) {
        const index = i * 3 + j;
        if (list[index] !== undefined) {
          postList[i][j] = list[index];
        } else {
          break;
        }
      }
    }

    return p.posts.concat(postList);
  };

  p.handleSetCategory = (category, uniqTitle) => {
    if (category !== p.data.category) {
      deletedPostManager.reset('category');
      p.setPostLoaded(false);
      p.setPosts([]);
      p.setData({
        category: category,
        uniqTitle: uniqTitle,
        pageNumber: 0,
      });
      p.setPageNumber(0);
    }
  };

  return <PostsListContext.Provider value={[p]}>{props.children}</PostsListContext.Provider>;
}

export default CategoryPostsListProvider;
